module.exports = __webpack_public_path__ + "img/header6.7015dfca.png";